var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRiskIconFinancial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2820_22523)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2820_22523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 12H8V20H2V12ZM9 2H15V20H9V2ZM16 7H22V20H16V7Z",
    fill: "#09121F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2820_22523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2820_22523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 -1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskIconFinancial);
export default __webpack_public_path__ + "static/media/risk-icon-financial.30a5f2ebb31c9077e1224b87cf562780.svg";
export { ForwardRef as ReactComponent };